var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    strokeWidth: 0.576,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1333 22.1333C28.0381 22.1333 31.2 18.9714 31.2 15.0667C31.2 11.1619 28.0381 8 24.1333 8C20.2286 8 17.0667 11.1619 17.0667 15.0667C17.0667 18.9714 20.2286 22.1333 24.1333 22.1333ZM33.2 15.0667C33.2 20.076 29.1426 24.1333 24.1333 24.1333C19.124 24.1333 15.0667 20.076 15.0667 15.0667C15.0667 10.0573 19.124 6 24.1333 6C29.1426 6 33.2 10.0573 33.2 15.0667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1254 27.6282C17.8971 27.1604 17.3814 26.9076 16.8786 27.0312C11.4745 28.3592 6 31.0671 6 35.1407V40V42H8H40H42V40V35.1407C42 31.0671 36.5255 28.3592 31.1214 27.0312C30.6186 26.9076 30.1029 27.1604 29.8746 27.6282L25.8105 27.6282C24.9218 27.6284 24.4693 27.6284 24.0248 27.6284C23.5637 27.6283 23.1112 27.6283 22.1893 27.6285L18.1254 27.6282ZM25.8109 29.6282C25.8107 29.6282 25.8106 29.6282 25.8105 29.6282C24.9162 29.6284 24.466 29.6284 24.024 29.6284C23.5658 29.6283 23.1162 29.6283 22.1898 29.6285L22.1892 29.6285L18.1252 29.6282L16.8758 29.6281L16.6456 29.1564C14.3233 29.7829 12.1328 30.655 10.5162 31.7244C8.69262 32.9307 8 34.0995 8 35.1407V40H40V35.1407C40 34.0995 39.3074 32.9307 37.4838 31.7244C35.8672 30.655 33.6767 29.7829 31.3544 29.1564L31.1242 29.6282L29.8746 29.6282L25.8109 29.6282Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 34.9038C16.5384 34.9038 17 34.4601 17 33.8816C17 33.3031 16.5384 32.8594 16 32.8594C15.4616 32.8594 15 33.3031 15 33.8816C15 34.4601 15.4616 34.9038 16 34.9038ZM16 36.9038C17.6569 36.9038 19 35.5507 19 33.8816C19 32.2125 17.6569 30.8594 16 30.8594C14.3431 30.8594 13 32.2125 13 33.8816C13 35.5507 14.3431 36.9038 16 36.9038Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6354 28.6117C15.4178 29.3461 15.4391 30.25 15.8901 31.3606L14.0371 32.1131C13.5935 31.0208 13.4293 29.9763 13.5293 28.9999C13.5627 28.6732 13.6258 28.3541 13.7178 28.0435L15.6354 28.6117Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5348 31.496L34.476 31.9777C34.7266 30.9679 34.7789 30.0189 34.65 29.1395L32.4114 28.4784C32.743 29.284 32.8379 30.2747 32.5348 31.496Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4268 31.225C31.6053 31.0795 31.8285 31 32.0588 31H34.9412C35.1715 31 35.3947 31.0795 35.5732 31.225L37.632 32.904C37.8649 33.094 38 33.3785 38 33.679V38.0444C38 38.5967 37.5523 39.0444 37 39.0444H34.9412V37.0444H36V34.1539L34.5851 33H32.4149L31 34.1539V37.0444H32.0588V39.0444H30C29.4477 39.0444 29 38.5967 29 38.0444V33.679C29 33.3785 29.1351 33.094 29.368 32.904L31.4268 31.225Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.e370900b3d11d216ff5ce31dbd6a0954.svg";
export { ForwardRef as ReactComponent };